<template>
  <div class="faq" redesign>
    <!-- Header -->
    <div class="local-hero">
      <h1 class="local-hero-header" v-translate>Frequently Asked Questions</h1>
    </div>

    <LogoHeader :org="organizationDetails" />

    <!-- faq table of contents -->
    <div class="form-container faq-table">
      <ul class="faq-list">
        <li v-for="(faq, i) in faqs.list" :key="i" class="form-field card-shape">
          <div class="form-field-container">
            <FAQComponent :faq="faq" />
          </div>
        </li>
      </ul>
    </div>

    <!-- faqs -->
    <LoadSpinner v-if="faqs.loadingNextPage" />

    <div class="pagination-container">
      <button
        class="button"
        @click="() => faqs.prevPage()"
        v-if="faqs.pagination.hasPrevPage"
        :disabled="!faqs.pagination.hasPrevPage"
      >
        <font-awesome-icon
          class="pagination-icons"
          :icon="['fa', 'chevron-left']"
          :style="{ fontSize: '25px' }"
        ></font-awesome-icon>
      </button>

      <button
        class="button"
        @click="() => faqs.nextPage()"
        v-if="faqs.pagination.hasNextPage"
        :disabled="!faqs.pagination.hasNextPage"
      >
        <font-awesome-icon
          class="pagination-icons"
          :icon="['fa', 'chevron-right']"
          :style="{ fontSize: '25px' }"
        ></font-awesome-icon>
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import FAQ from '../services/faqs'
import CollectionManager from '../services/collectionManager'
import Pagination from '../services/pagination'
import FAQComponent from '../components/FAQComponent'
import { analyticsMixin } from '@/services/googleAnalytics'
import LogoHeader from '@/components/LogoHeader'

export default {
  name: 'FAQ',
  mixins: [analyticsMixin],
  components: {
    FAQComponent,
    LogoHeader,
  },
  data() {
    return {
      faqs: CollectionManager.create({
        pagination: Pagination.create({ pageSize: 40 }),
        ModelClass: FAQ,
        filters: { ordering: 'order' },
      }),
    }
  },
  async created() {
    this.refresh()
  },
  updated() {
    /** check whether the route has a hash
     * if a hash is available remove the # from the string and get the
     * element with an id equal to the hash value
     * window scroll to top of element equal to hash value
     */
    if (this.$route.hash) {
      const faqIdValue = this.$route.hash.replace(/[^\w\s]/gi, '')
      let faqElement = document.getElementById(`${faqIdValue}`)
      let faqContent = faqElement.getBoundingClientRect()

      window.scrollTo(0, faqContent.top)
    }
  },
  methods: {
    refresh() {
      this.faqs.refresh()
    },
    trackClick(faqNumber) {
      this.trackClickedCTA(`FAQ #${faqNumber} at top of page`)
    },
  },
  watch: {
    '$language.current': async function() {
      await this.faqs.refresh()
    },
    currentLanguage: async function() {
      await this.faqs.refresh()
    },
  },
  computed: { ...mapState(['user', 'organizationDetails', 'currentLanguage']) },
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables';
@import '@/styles/mixins/buttons';
@import '@/styles/mixins/containers';
@import '@/styles/mixins/responsive';

.faq {
  display: flex;
  flex-direction: column;
}

.faq-list {
  padding-left: 0;
  list-style: none;

  & > li {
    margin-left: 0;
  }

  .form-field-container {
    margin-top: 0;
  }
}

.faq-table {
  max-width: 856px;
  align-self: center;
}
</style>
